import { Card } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AuthHelper } from '../../../auth/auth-helper';
import {
  RBHBox,
  RBHButton,
  RBHText,
  RBHImage,
} from '../../../shared/components';
import styleButton from '../../../shared/components/rbh-button/styles';
import styleText from '../../../shared/components/rbh-text/styles';
import { Images } from '../../../shared/theme';
import { mainCreators } from '../../main-action';
import { BUSINESS_TYPE } from '../../main-constant';
import { MAIN_STATE_KEY } from '../../main-reducer';
import styles from './styles';

export const MainScreen: React.FC<Props> = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isMart = AuthHelper.getBusinessTypeId() === BUSINESS_TYPE.MART;

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 0));
  }, []);

  const callConfirmAllChange = () => {
    dispatch(mainCreators.postConfirmAllChange());
  };
  return (
    <RBHBox style={styles.defaultContent}>
      <RBHBox id={'id-main-box-title'} style={styles.titleBox}>
        <RBHText
          id={'id-main-text-title'}
          style={styleText.textTitle}
          data-testid={'id-main-text-title'}
          text={'main.title'}
        />
        <RBHText
          id={'id-main-text-description'}
          style={styleText.text16DarkGray}
          data-testid={'id-main-text-description'}
          text={`main.description.${isMart ? 'mart' : 'food'}`}
        />
      </RBHBox>
      {isMart ? (
        <RBHImage
          data-testid={'mart-main-image'}
          id={'mart-main-image'}
          style={styles.martImage}
          src={Images.mainMart}
        />
      ) : (
        <RBHBox style={styles.container}>
          <RBHBox style={styles.cardBox}>
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'branchmanagement-1'}
                onClick={() => {
                  history.push('/main/branchmanagement');
                }}
                hoverable
                cover={
                  <img
                    id={'img-branchmanagement'}
                    style={styles.imageBox}
                    src={Images.landingStep.step1}
                  />
                }
                style={styles.cardCover}
                bodyStyle={styles.cardBody}
              >
                <RBHText
                  id={'text-branchmanagement'}
                  style={styles.titleContent}
                  text={'main.card1'}
                />
              </Card>
            </RBHBox>
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'usermanagement-2'}
                onClick={() => {
                  history.push('/main/usermanagement');
                }}
                hoverable
                cover={
                  <img
                    id={'img-usermanagement'}
                    style={styles.imageBox}
                    src={Images.landingStep.step2}
                  />
                }
                style={styles.cardCover}
                bodyStyle={styles.cardBody}
              >
                <RBHText
                  id={'text-usermanagement'}
                  style={styles.titleContent}
                  text={'main.card2'}
                />
              </Card>
            </RBHBox>
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'vataddress-3'}
                onClick={() => {
                  history.push('/main/vataddress');
                }}
                hoverable
                cover={
                  <img
                    id={'img-vat_vataddress'}
                    style={styles.imageBox}
                    src={Images.landingStep.step3}
                  />
                }
                style={styles.cardCover}
                bodyStyle={styles.cardBody}
              >
                <RBHText
                  id={'text-vat_vataddress'}
                  style={styles.titleContent}
                  text={'main.card3'}
                />
              </Card>
            </RBHBox>
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'vat_to_brance-4'}
                onClick={() => {
                  history.push('/main/branchmanagement');
                }}
                hoverable
                cover={
                  <img
                    id={'img-vat_vataddress_brance'}
                    style={styles.imageBox}
                    src={Images.landingStep.step4}
                  />
                }
                style={styles.cardCover}
                bodyStyle={styles.cardBody}
              >
                <RBHText
                  id={'text-vat_vataddress_brance'}
                  style={styles.titleContent}
                  text={'main.card4'}
                />
              </Card>
            </RBHBox>
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'foodcategory-5'}
                onClick={() => {
                  history.push('/main/foodcategory');
                }}
                hoverable
                cover={
                  <img
                    id={'img-foodcategory'}
                    style={styles.imageBox}
                    src={Images.landingStep.step5}
                  />
                }
                style={styles.cardCover}
                bodyStyle={styles.cardBody}
              >
                <RBHText
                  id={'text-foodcategory'}
                  style={styles.titleContent}
                  text={'main.card5'}
                />
              </Card>
            </RBHBox>
            <RBHBox style={styles.cardSuccess}>
              <Card
                id={'foodmenu-6'}
                onClick={() => {
                  history.push('/main/foodmenu');
                }}
                hoverable
                cover={
                  <img
                    id={'img-foodmenu'}
                    style={styles.imageBox}
                    src={Images.landingStep.step6}
                  />
                }
                style={styles.cardCover}
                bodyStyle={styles.cardBody}
              >
                <RBHText
                  id={'text-foodmenu'}
                  style={styles.titleContent}
                  text={'main.card6'}
                />
              </Card>
            </RBHBox>
          </RBHBox>
          <RBHBox style={styles.buttonBox}>
            <RBHButton
              block
              style={styleButton.buttonGradient}
              id={'button_register'}
              text={'main.register'}
              onClick={callConfirmAllChange}
            />
          </RBHBox>
        </RBHBox>
      )}
    </RBHBox>
  );
};

type Props = {};
